export default __webpack_public_path__ + "static/media/section4_bubble_left.d8fa62ad.png";